import { useEffect, useState } from 'react';
import { Modal } from 'src/components/baseComponents';
import { CommonFormProps } from '.';
import { analytics } from 'src/services/analytics';
import { getAppointmentDetailsForAnalytics } from 'src/utils';

type Props = CommonFormProps;

export const DVPRS = ({
  isOpen,
  onSave,
  appointment,
  form,
  loading,
}: Props) => {
  const dpvrsForm = form.content as any[];
  const [initialValues, setInitialValues] = useState({});
  const [fields, setFields] = useState<any[]>([]);
  const leftLegend = [
    'Does not interfere',
    'Does not interfere',
    'Does not affect',
    'Does not contribute',
  ];
  const rightLegend = [
    'Completely interferes',
    'Completely interferes',
    'Completely affects',
    'Contributes a great deal',
  ];
  const [dvprsImage_url, setDvprsImage_url] = useState('');

  useEffect(() => {
    const updatedValuesArray = dpvrsForm.map((curr) => {
      if (curr.item != undefined) {
        const key = curr.item.toLowerCase().replace(/\s+/g, '_');
        return { [key]: '' };
      }
      return false;
    });

    const updatedValues = Object.assign({}, ...updatedValuesArray);
    setInitialValues(updatedValues);
  }, [dpvrsForm]);

  useEffect(() => {
    const transformedArray = dpvrsForm.map((item, index) => {
      if (item.s3_url) {
        setDvprsImage_url(item.s3_url);
      }
      if (item?.type !== 'header' && item?.type !== 'label') {
        const transformedItem = {
          name: item?.item?.toLowerCase().replace(/\s+/g, '_'),
          type: item?.type,
          title: item?.item,
          placeholder: item?.placeholder || '',
          autoComplete: 'off',
          leftLegend: leftLegend[index - 2],
          rightLegend: rightLegend[index - 2],
        };
        Object.assign(transformedItem, { options: item?.options });
        return transformedItem;
      }
      return {
        name: item.item,
        type: item.type,
        title: item.item,
      };
    });
    transformedArray.pop();
    setFields(transformedArray);
  }, [dpvrsForm]);

  const filterValues = (values: Record<string, any>) => {
    const filtered: Record<string, any> = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== '') {
        filtered[key] = value;
      }
    }
    return filtered;
  };

  const handleSubmit = async (values: Record<string, any>) => {
    analytics.track(
      'Clicked Submit In DVPRS Form',
      getAppointmentDetailsForAnalytics(appointment!)
    );
    if (!values) {
      return;
    }

    const filteredValues = filterValues(values);
    const flattenedValues = Object.values(filteredValues).flatMap(
      Object.values
    );

    if (
      Object.keys(filteredValues).length !== 4 ||
      flattenedValues.includes(-1)
    ) {
      document
        .querySelector('.dvprs-error-message')
        ?.classList.remove('invisible');
    } else {
      const payload = {
        response: filteredValues,
        form_type: 'DVPRS',
      };
      await onSave(payload);
    }
  };

  return (
    <div>
      {/** @ts-ignore */}
      <Modal
        open={isOpen}
        className={'dvprs_modal'}
        formClassName={'flex flex-col my-6'}
        initialValues={initialValues}
        submitButtonText="Submit"
        cancelButtonText=""
        closable={false}
        centered={true}
        fields={fields}
        handleSubmit={handleSubmit}
        onSubmitLoading={loading}
        disableSubmit={loading}
        titleBody={
          <div style={{ textAlign: 'center' }} className="lg:w-full mb-7">
            <img
              src={dvprsImage_url}
              alt="DVPRS image"
              className="shadow-xl p-2 rounded-xl"
            />
          </div>
        }
        additionalBody={
          <div className="dvprs-error-message invisible text-red-600 my-2 text-center">
            Please choose a value between 0 and 10 for all the questions
          </div>
        }
      />
    </div>
  );
};
